import React from 'react';
import ConnectionCard from './ConnectionCard';
import BestMatchesWidget from './BestMatchesWidget';
// Sample data for connections
const connectionsData = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Data Scientist @ Intel',
  location: 'Milano, Italia',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 95,
  tags: ['AI', 'Machine Learning', 'ESG'],
  matchReason: 'Avete partecipato agli stessi 3 corsi e condividete interessi in AI e sostenibilità',
  connectionType: 'both',
  isConnected: true
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'ML Engineer @ Google',
  location: 'Roma, Italia',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 88,
  tags: ['Deep Learning', 'Computer Vision', 'Sostenibilità'],
  matchReason: 'Competenze complementari in Deep Learning e Computer Vision. Entrambi interessati a progetti di sostenibilità',
  connectionType: 'course',
  isConnected: true
}, {
  id: 3,
  name: 'Alessandro Verdi',
  role: 'Sustainability Manager @ Enel',
  location: 'Firenze, Italia',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 82,
  tags: ['ESG', 'Energia Rinnovabile', 'Reporting'],
  matchReason: 'Entrambi specializzati in strategie ESG e avete completato il corso di Innovazione Sostenibile',
  connectionType: 'both',
  isConnected: true
}, {
  id: 4,
  name: 'Giulia Neri',
  role: 'Circular Economy Specialist @ Accenture',
  location: 'Milano, Italia',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 78,
  tags: ['Economia Circolare', 'Sostenibilità', 'Consulenza'],
  matchReason: 'Condividete interessi in economia circolare e strategie di sostenibilità aziendale',
  connectionType: 'connected',
  isConnected: true
}, {
  id: 5,
  name: 'Paolo Marini',
  role: 'Green Finance Advisor @ Intesa',
  location: 'Torino, Italia',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 75,
  tags: ['Green Finance', 'ESG', 'Investimenti Sostenibili'],
  matchReason: 'Competenze complementari in finanza sostenibile e reporting ESG',
  connectionType: 'course',
  isConnected: false
}, {
  id: 6,
  name: 'Chiara Esposito',
  role: 'Corporate Sustainability @ Eni',
  location: 'Roma, Italia',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 71,
  tags: ['Corporate Sustainability', 'Carbon Management', 'ESG'],
  matchReason: 'Entrambi lavorano nel settore della sostenibilità aziendale con focus su carbon management',
  connectionType: 'course',
  isConnected: false
}];
interface ConnectionsListProps {
  activeFilter: 'all' | 'courses' | 'connected';
  searchQuery: string;
}
const ConnectionsList: React.FC<ConnectionsListProps> = ({
  activeFilter,
  searchQuery
}) => {
  // Filter connections based on active filter and search query
  const filteredConnections = connectionsData.filter(connection => {
    // Filter by connection type
    if (activeFilter === 'courses' && connection.connectionType !== 'course' && connection.connectionType !== 'both') {
      return false;
    }
    if (activeFilter === 'connected' && !connection.isConnected) {
      return false;
    }
    // Filter by search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return connection.name.toLowerCase().includes(query) || connection.role.toLowerCase().includes(query) || connection.location.toLowerCase().includes(query) || connection.tags.some(tag => tag.toLowerCase().includes(query));
    }
    return true;
  });
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-718">
      <BestMatchesWidget connections={connectionsData} data-id="element-719" />
      {filteredConnections.map(connection => <ConnectionCard key={connection.id} connection={connection} data-id="element-720" />)}
      {filteredConnections.length === 0 && <div className="col-span-full bg-white rounded-xl border border-gray-200 p-8 text-center" data-id="element-721">
          <p className="text-gray-600" data-id="element-722">
            Nessuna connessione trovata con i filtri selezionati.
          </p>
        </div>}
    </div>;
};
export default ConnectionsList;